const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function track(event, meta = {}) {
  try {
    const payload = JSON.stringify({ event, meta });
    if (navigator.sendBeacon) {
      navigator.sendBeacon(`${API}/track`, new Blob([payload], { type: "application/json" }));
    } else {
      fetch(`${API}/track`, { method: "POST", headers: { "Content-Type": "application/json" }, body: payload, keepalive: true });
    }
  } catch { /* never block UX on analytics */ }
}
